module.exports = __webpack_public_path__ + "static/media/1-leds-light-beam-compressed.baa79a5c.png";